// Shared by the FlightDocument and FlightExpense helpers so the two strips cannot drift apart.

type OrderableRecord = { createdAt: Date; id: string };

export const compareNewestFirstThenById = (left: OrderableRecord, right: OrderableRecord): number => {
    const byNewestFirst = right.createdAt.getTime() - left.createdAt.getTime();
    return byNewestFirst === 0 ? left.id.localeCompare(right.id) : byNewestFirst;
};

// Flagging a never-uploaded record jams the sync queue on a blob that is gone. Check contentKey,
// not _version: a create can succeed while its response is lost.
export const deleteByUploadState = <T extends { deleted: boolean; id: string }>(
    records: T[],
    recordId: string,
    isUploaded: (record: T) => boolean
): { idsToPurge: string[]; records: T[] } => {
    const target = records.find((record) => record.id === recordId);
    if (!target) {
        return { idsToPurge: [], records };
    }
    if (!isUploaded(target)) {
        return {
            idsToPurge: [recordId],
            records: records.filter((record) => record.id !== recordId),
        };
    }
    return {
        idsToPurge: [],
        records: records.map((record) => (record.id === recordId ? { ...record, deleted: true } : record)),
    };
};
